export default __webpack_public_path__ + "static/media/gallery_03.e02de2c9.jpg";